import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '../../atoms/text'
import { StyledContent, StyledRadio, StyledWrapper } from './styles'

export const SelectBankAccountCard = ({
  isChecked = false,
  onClick = () => {},
  bankAccount = {},
}) => {
  const handleClick = () => {
    onClick(bankAccount)
  }
  return (
    <StyledWrapper onClick={handleClick}>
      <div>
        <StyledRadio $checked={isChecked} />
        <input type="radio" name="role" checked={isChecked} />
      </div>
      <StyledContent>
        <div>
          <Text bold style={{ marginBottom: 5, lineHeight: '26px' }}>
            {bankAccount.bank.name}
          </Text>
          <Text small style={{ marginBottom: 4 }}>
            Ag {bankAccount.bankBranch} | {bankAccount.accountNumber}
          </Text>
          <Text small noMargin>
            {bankAccount.accountType}
          </Text>
        </div>
      </StyledContent>
    </StyledWrapper>
  )
}

SelectBankAccountCard.propTypes = {
  isChecked: PropTypes.bool,
  onClick: PropTypes.func,
  bankAccount: PropTypes.shape({
    bankBranch: PropTypes.string,
    accountNumber: PropTypes.string,
    accountType: PropTypes.string,
    bank: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
}
